import React, { Component } from "react";
import { Button, Table } from "semantic-ui-react";

export const FormattedRow = (props) => {
  if (props.header) {
    return (
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell content={props.description} />
          {props.data.map((d, i) => (
            <Table.HeaderCell key={i} content={d !== undefined ? d : "n/a"} />
          ))}
        </Table.Row>
      </Table.Header>
    );
  }

  return (
    <Table.Row warning={props.warning}>
      <Table.Cell content={props.description} />
      {props.data.map((d, i) => (
        <Table.Cell
          content={d !== undefined && d !== "$undefined" ? d : "n/a"}
          key={i}
        />
      ))}
    </Table.Row>
  );
};

const ButtonRow = (props) => (
  <Table.Row>
    <Table.Cell content="" />
    {props.data.map((d, i) => (
      <Table.Cell
        key={i}
        content={
          <Button
            color={props.selected == d ? "blue" : null}
            content="Select"
            onClick={() => props.onClick(d)}
          />
        }
      />
    ))}
  </Table.Row>
);

export const TermPicker = (props) => {
  const { plans, widget } = props;

  let payoffPercentages = ["55%", "48%", "45%", "40%"];

  if (props.isFinancial) {
    payoffPercentages = payoffPercentages.filter((p) => p !== "55%");
  }

  return (
    <div style={{ margin: "20px 0" }}>
      <Table size="large">
        <FormattedRow
          data={plans.map((p) => p.id)}
          description="Term (months)"
          header={true}
        />
        <Table.Body>
          {/* <FormattedRow
            data={plans.map(p => parseFloat(props.additionalCost) ? `$${parseFloat(props.additionalCost).toFixed(2)}` : '$0.00')}
            description="Additional Installation Materials"
          /> */}
          {!widget && (
            <React.Fragment>
              <FormattedRow
                data={plans.map((p) => `$${p.total_hvac_system_cost}`)}
                description="Cost of Unit (Cash Price)"
              />
              <FormattedRow
                data={plans.map((p) => `$${p.cash_total}`)}
                description="Total Cash Price Of Unit"
              />
              <FormattedRow
                data={plans.map((p) => `$${p.minimum_purchase_reserve}`)}
                description="Minimum Contract Reduction"
              />
              <FormattedRow
                data={plans.map((p) => `$${p.additional_down_payment}`)}
                description="Optional Added Cost Reduction"
              />
              <FormattedRow
                data={plans.map((p) => `$${p.total_purchase_reserve}`)}
                description="Total Cost Reduction (Down Payment)"
                warning={true}
              />
              <FormattedRow
                data={plans.map((p) => `$${p.tax_on_deposit}`)}
                description="Tax on Contract Reduction"
              />
              <FormattedRow
                data={plans.map((p) => `$${p.cost_reduction_after_tax}`)}
                description="Contract Reduction after Tax"
              />
              <FormattedRow
                data={plans.map((p) => `$${p.final_cost_of_unit}`)}
                description="Cost of Unit after Contract Reduction (Starting Rent to own amount)"
              />
              <FormattedRow
                data={plans.map((p) => `$${p.pre_tax_monthly}`)}
                description="Monthly Rent (Pre-tax)"
              />
              <FormattedRow
                data={plans.map((p) => props.taxRate)}
                description={`Tax Rate (${props.zip})`}
              />
              <FormattedRow
                data={plans.map((p) => `$${p.monthly_tax}`)}
                description="Sales tax"
              />
            </React.Fragment>
          )}
          <FormattedRow
            data={plans.map((p) => `$${p.total_monthly_payment}`)}
            description="Total Monthly Payment"
            warning={true}
          />
          {!widget && (
            <React.Fragment>
              <FormattedRow
                data={plans.map((p) => `$${p.full_term_payoff}`)}
                description="Total Contract Balance"
              />
              <FormattedRow
                data={payoffPercentages}
                description="Payoff Percentage Customer Pays on Remaining Balance"
              />
              <ButtonRow
                data={plans.map((p) => p.id)}
                onClick={props.onClick}
                selected={props.selectedTerm}
              />
            </React.Fragment>
          )}
        </Table.Body>
      </Table>
    </div>
  );
};
